import React from "react";

export const AppContext = React.createContext(null);

export const DispatchContext = React.createContext(null);
